/* eslint-disable no-unused-vars */
import axios from 'axios';
import api from '@src/api';
import _ from 'lodash';
import store from '@state/store';

export const state = initialState();

// state is a function so it can be instantiated again - reset
function initialState() {
  return {
    myTrainer: {},
  };
}

export const getters = {
  myTrainer(state) {
    return state.myTrainer;
  },
};

export const mutations = {
  setMyTrainer(state, newValue) {
    state.myTrainer = newValue;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {
  getMyTrainer({ state, commit }, trainerId) {
    if (trainerId && trainerId.length === 24) {
      const url = api.URL_TRAINER_PUBLIC_BIO.replace(':trainerID', trainerId);
      return axios
        .get(url)
        .then((response) => response.data)
        .then((response) => {
          const trainer = response.trainer;
          commit('setMyTrainer', trainer);
          return trainer;
        })
        .catch((err) => {
          if (err.response) {
            console.error(err.response);
          } else {
            console.error(err);
          }

          return null;
        });
    } else {
      return null;
    }
  },
};
